
module.exports = {
	extends: [
		'/',
		'base',
		'master',
		'master'
	],

	config: {
		staticLookupName: 'master'
	},

	methods: {},

	hooks: {
		_attach: function($element, options){
			if(!this.inIframe()){
				$element.find('body').addClass('fullScreen');
			}
		}
	}
};